module.exports = __webpack_public_path__ + "img/loading_huojian.1b858542.png";